<template>
  <div class="generate-post-step">
    <h1 class="global-h1">Generate the Post!</h1>

    <div class="generate-post-step__post-count">
      <span class="post-count-label">How many posts would you like?</span>
      <div class="post-count-options">
        <SrpSlider :min="1" :max="3" :value="props.selectedPostCount" @update:value="newValue => emit('update:selectedPostCount', newValue)" />
      </div>
    </div>

    <div class="generate-post-step__guidance-section">
      <div class="generate-post-step__quick-options">
        <span class="quick-start-label">Ex:</span>
        <a v-for="option in quickOptions" :key="option" href="#" class="quick-option-link" @click.prevent="selectQuickOption(option)">
          {{ option }}
        </a>
      </div>
      <textarea v-model="userGuidance" class="generate-post-step__guidance-input" placeholder="or provide some guidance..." rows="3"></textarea>

      <NoteWithIcon class="generate-post-step__info-note" size="small" color="green">
        <template #text>
          <h6 class="global-h6">Posts can take 30-60 seconds to generate.</h6>
        </template>
      </NoteWithIcon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from "vue";
import SrpSlider from "@components/ui/SrpSlider.vue";
import NoteWithIcon from "@components/NoteWithIcon.vue";

const quickOptions = ["General post", "Highlight the seasons", "Focus on people", "Outdoor activities"];

const props = defineProps<{
  photoCount: number;
  selectedPostCount: number;
}>();

const userGuidance = ref<string>("");

const emit = defineEmits<{
  (e: "update:selectedPostCount", value: number): void;
  (e: "update:userGuidance", value: string): void;
}>();

watch(userGuidance, newValue => {
  emit("update:userGuidance", newValue);
});

const selectQuickOption = (option: string) => {
  userGuidance.value = option;
};
</script>

<style scoped lang="scss">
.generate-post-step {
  &__guidance-section {
    margin-top: 24px;
  }

  &__quick-options {
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;

    .quick-start-label {
      margin-left: 3px;
    }

    .quick-option-link {
      text-decoration: underline;
      text-decoration-style: dashed;
      text-decoration-color: #0006;
      cursor: pointer;

      &:hover {
        text-decoration: none;
        opacity: 0.8;
      }
    }
  }

  &__guidance-input {
    padding: 12px;
    height: 70px;
    max-width: 500px;
    border-radius: 4px;
    resize: vertical;
    min-height: 80px;
    font-family: inherit;
  }

  &__post-count {
    margin-top: 24px;

    .post-count-label {
      display: block;
      margin-bottom: 12px;
    }

    .post-count-options {
      display: flex;
      gap: 12px;
    }

    .post-count-button {
      padding: 8px 16px;
      border: 1px solid #ddd;
      border-radius: 4px;
      background: white;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: #f5f5f5;
      }

      &.active {
        background: #000;
        color: white;
        border-color: #000;
      }
    }
  }

  &__info-note {
    max-width: 370px;
    margin-top: 16px;
    color: #666;
    font-size: 0.9em;
  }
}
</style>
